import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {NbFieldType, NbMassiveItem} from './nbinput.entity';


@Component({
  selector: 'nbinput-select',
  template: require('./nbinput-select.component.html'),
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => NbinputSelectComponent),
    multi: true,
  }]
})

export class NbinputSelectComponent implements ControlValueAccessor {
  private onTouchedCallback = () => {};
  private onChangeCallback = (_) => {};
  registerOnChange(fn: any): void {if (fn) { this.onChangeCallback = fn; }}
  registerOnTouched(fn: any): void {if (fn) { this.onTouchedCallback = fn; }}
  setDisabledState?(isDisabled: boolean): void {this.disabled = isDisabled; }
  writeValue(obj: any ): void { this.data = obj; }

  multiple = false;
  @Input()
  set type(t: NbFieldType) {
    this.multiple = (t && t == NbFieldType.Multiple);
  }
  get type() {
    return this.multiple ? NbFieldType.Multiple : NbFieldType.Massive;
  }

  _items: Array<NbMassiveItem> = [];
  @Input()
  set options(val) {
    if (val) {
      // console.log('opts:', val);
      this._items = val;
      if (this.readonly && (this._data != undefined && this._data != null)) {
        this.setSelected();
      }
    }
  }
  _data: any;
  get data(): any {
    return this._data;
  };
  @Input()
  set data(val: any) {
    this._selectedTexts = [];
    if (val != null && val != undefined) {
      if (this.multiple && (typeof val === 'string' || !Array.isArray(val))) {
        this._data = [val];
      } else {
        this._data = val;
      }
      if (this.readonly && !!this._items && this._items.length > 0) {
        this.setSelected();
      }
    } else {
      this._data = null;
    }
  }

  _selectedCss: string[] = [];
  _selectedTexts: string[] = [];
  setSelected() {
    // console.log('set selected text: ',this._data);
    this._selectedTexts = [];
    if (this.multiple) {
      this._data.forEach(d => {
        const item = this._items.find(f => f.value == d);
        if (item) {
          this._selectedTexts.push(item.text);
          let selc = '';
          if (item.css) {
            if (typeof item.css == 'string') {
              selc = item.css;
            } else if (typeof item.css == 'object' && typeof item.css.length == 'number') {
              selc = item.css.join(' ');
            }
          }
          this._selectedCss.push(selc);
        }
      });
    } else {
      const item = this._items.find(f => f.value == this._data);
      if (item) {
        this._selectedTexts = [item.text];
        let selc = '';
        if (item.css) {
          if (typeof item.css == 'string') {
            selc = item.css;
          } else if (typeof item.css == 'object' && typeof item.css.length == 'number') {
            selc = item.css.join(' ');
          }
        }
        this._selectedCss = [selc];
      }
    }
  }

  @Input()
  readonly = false;

  @Input()
  placeholder = '';

  disabled = false;

  @Output()
  public open: EventEmitter<any> = new EventEmitter();
  onOpen(e) {
    // console.log('onOpen: ', e);
    this.open.emit(e);
  }
  @Output()
  public close: EventEmitter<any> = new EventEmitter();
  onClose(e) {
    // console.log('onClose: ', e);
    this.close.emit(e);
  }
  @Output()
  public focus: EventEmitter<any> = new EventEmitter();
  onFocus(e) {
    // console.log('onFocus: ', e);
    this.focus.emit(e);
  }
  @Output()
  public search: EventEmitter<any> = new EventEmitter();
  onSearch(e) {
    // console.log('onSearch: ', e);
    this.search.emit(e.value);
  }
  @Output()
  public blur: EventEmitter<any> = new EventEmitter();
  onBlur(e) {
    // console.log('onBlur: ', e);
    this.blur.emit(e.value);
  }
  @Output()
  public clear: EventEmitter<any> = new EventEmitter();
  onClear(e) {
    // console.log('onClear: ', e);
    this.clear.emit(e.value);
  }
  @Output()
  public add: EventEmitter<any> = new EventEmitter();
  onAdd(e) {
    // console.log('onAdd: ', e);
    this.add.emit(e.value);
  }
  @Output()
  public scrollToEnd: EventEmitter<any> = new EventEmitter();
  onScrollToEnd(e) {
    // console.log('scrollToEnd: ', e);
    this.scrollToEnd.emit(e.value);
  }
  @Output()
  public remove: EventEmitter<any> = new EventEmitter();
  onRemove(e) {
    // console.log('onRemove: ', e);
    this.remove.emit(e.value);
  }
  @Output()
  public change: EventEmitter<any> = new EventEmitter();
  onChange(e) {
    // console.log('onChange: ', e);
    if (Array.isArray(e)) {
      this.change.emit(e.map(s => s.value));
      this.onChangeCallback(e.map(s => s.value));
    } else {
      this.change.emit(e ? e.value : null);
      this.onChangeCallback(e.value);
    }
  }

  @Input()
  formControlName: string;
}
